<template>
  <div :class="$style.currentUserCounterSection">
    <h6 :class="$style.currentUsersTitle">
      Currently in JumpCloud
    </h6>
    <span :class="$style.currentUsers">{{ currentUsersCount }}</span>
    <span :class="$style.currentUsersLabel">users</span>
  </div>
</template>

<script>
import { ItemTypeConsts, StoreModuleMap } from 'client/util/Constants';
import { get } from 'lodash';
import { mapActions, mapGetters, mapState } from 'vuex';

const organizationsCollection = StoreModuleMap[ItemTypeConsts.organizations];
const settingsModule = StoreModuleMap[ItemTypeConsts.settings];
export default {
  name: 'ImportUserCurrentCount',

  computed: {
    ...mapState(settingsModule, ['orgId']),
    ...mapGetters(organizationsCollection, ['getItemDetails']),

    currentUsersCount() {
      const systemUsersCount = get(this.getItemDetails(this.orgId), 'systemUsersCount', 0);
      return systemUsersCount;
    },
  },

  created() {
    this.getDetailsForOrganization({ id: this.orgId });
  },

  methods: mapActions(organizationsCollection, ['getDetailsForOrganization']),
};
</script>

<style module>
@value ( jcGrey, jcGrey800 ) from '~css/brand-colors.css';

.currentUserCounterSection {
  align-items: center;
  display: grid;
  font-size: 1.077rem;
  gap: 0 6px;
  grid-template:
    "title title" auto
    "currentUsers currentUsersLabel" auto / min-content 1fr;
  line-height: 1.286;
  margin: 0 1.15rem 0 0.4rem;
  text-align: left;
}

.currentUserCounterSection > .currentUsersTitle {
  color: jcGrey;
  grid-area: title;
  margin: 0;
}

.currentUserCounterSection > .currentUsers {
  color: jcGrey800;
  font-size: 1.38rem;
  font-weight: bold;
  grid-area: currentUsers;
  line-height: 1.28;
}

.currentUserCounterSection > .currentUsersLabel {
  color: jcGrey800;
  font-weight: 600;
  grid-area: currentUsersLabel;
  line-height: 1.286;
}
</style>
